import {Injectable} from '@angular/core';
import {
  IResourceMethod,
  ResourceAction,
  ResourceHandler,
  ResourceParams,
  ResourceRequestMethod
} from '@ngx-resource/core';
import {CategoriaModel} from './categoria';
import {Category} from './category.model';
import {ResourceAuth} from "../../common.module/auth/authenticate.resource";
import {AuthServerProvider} from "../../common.module/auth/auth-jwt.service";

@Injectable()
@ResourceParams({
  pathPrefix: '/configuracion'
  // url: 'http://localhost:8003'
})
export class CategoriasResource extends ResourceAuth {
  constructor(restHandler: ResourceHandler, authProv: AuthServerProvider) {
    super(restHandler, authProv);
  }
/*export class CategoriasResource extends Resource {
   constructor(restHandler: ResourceHandler) {
     super(restHandler);
   }*/

  @ResourceAction({
    path: '/categoria'
  })
  lodListaCategorias: IResourceMethod<any, CategoriaModel[]>;

  @ResourceAction({
    path: '/categoria_activas'
  })
  lodListaCategoriasActivas: IResourceMethod<any, CategoriaModel[]>;

  @ResourceAction({
    path: '/categoria/{!id}'
  })
  lodCategoria: IResourceMethod<{ id: any }, CategoriaModel>;

  @ResourceAction({
    path: '/categoria',
    method: ResourceRequestMethod.Post
  })
  crtCategoria: IResourceMethod<CategoriaModel, any>;

  @ResourceAction({
    path: '/categoria/{!_id}',
    method: ResourceRequestMethod.Patch
  })
  updCategoria: IResourceMethod<CategoriaModel, any>;

  @ResourceAction({
    path: '/na/categorias_busqueda?s={!s}'
  })
  lodListaCategoriasPublic: IResourceMethod<{ s: any }, CategoriaModel[]>;

  @ResourceAction({
    path: '/na/categoria'
  })
  lodCategoriaPublic: IResourceMethod<any, Category>;

  @ResourceAction({
    path: '/na/categoria_nombre/{!id}'
  })
  lodCategoriaNombre: IResourceMethod<{ id: string }, CategoriaModel>;
}
